import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { API_BASE } from './api/client';
import './JobApplicationForm.css';

const JobApplicationForm = () => {
    const location = useLocation();
    const { formElements, jobId } = location.state || {};

    const [formData, setFormData] = useState({});

    if (!formElements) {
        return <p>No form data available. Please go back and select a job.</p>;
    }

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData({
            ...formData,
            [name]: type === "file" ? files[0] : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (!token) {
            alert("Please sign in again.");
            return;
        }
        const formPayload = new FormData();
        formPayload.append('jobId', jobId);
        Object.entries(formData).forEach(([key, value]) => {
            formPayload.append(key, value);
        });

        try {
            const response = await fetch(`${API_BASE}/api/job/apply`, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formPayload,
            });
    
            if (response.ok) {
                alert("Application submitted successfully!");
            } else {
                const errorData = await response.json();
                alert(errorData.error || "Failed to submit the application. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting the application:", error);
            alert("An error occurred while submitting the application.");
        }
    };
    return (
        <div className="job-application">
            <h2>Job Application Form</h2>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
                {formElements.map(element => (
                    <div key={element._id} className="form-group">
                        <label htmlFor={element.name}>{element.label}</label>
                        {element.type === "textarea" ? (
                            <textarea
                                id={element.name}
                                name={element.name}
                                onChange={handleInputChange}
                            ></textarea>
                        ) : element.type === "select" ? (
                            <select
                                id={element.name}
                                name={element.name}
                                onChange={handleInputChange}
                            >
                                {element.options.map(option => (
                                    <option key={option._id} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        ) : (
                            <input
                                type={element.type}
                                id={element.name}
                                name={element.name}
                                onChange={handleInputChange}
                            />
                        )}
                    </div>
                ))}
                <button type="submit" className="submit-button">
                    <i className="fas fa-paper-plane"></i> Submit Application
                    </button>
            </form>
        </div>
    );
};

export default JobApplicationForm;
